<div class="col-lg-12 py-4">
    <div class="row">
        <div class="col-md-8 col-lg-8 col-xl-6">
            <div class="card-custom card-body">
                <div class="code_cardTitle">
                    <div class="code-box_title">
                        <div class="title">
                            <h4>{{ 'SETTING_PAGE.IDMS_SETTINGS.CONFIGURE_BARCODE_QR_CODE' | transloco }}</h4>
                        </div>
                    </div>
                </div>
                <div class="code_box code_details_box mb-10" *ngIf="barcodeFormGroup" [formGroup]="idmsFormGroup.get('barcodeFormGroup')">
                    <div class="col-lg-12">
                        <div class="row mb-3 mx-1">
                            <div class="col-xl-4 col-lg-5 col-5">
                                <mat-label class="text-dark mt-4 mb-4 font-14 font-400 labelpbutton">
                                    <!-- Method -->
                                    {{ 'SETTING_PAGE.IDMS_SETTINGS.REPORTS_DRAWINGS' | transloco }}
                                </mat-label>
                            </div>

                            <div class="col-xl-8 col-lg-7 col-7 barcode-select-btn">
                                <div class="row">
                                    <div class="col-6">
                                        <div class="btn-group custom-toggle-wrap" role="group">
                                            <label
                                                *ngFor="let opt of stateOptions"
                                                class="btn custom-toggle"
                                                [class.active]="opt.value === idmsFormGroup.get('barcodeFormGroup').get('ReportBarcode_Visible')?.value"
                                            >
                                                <input
                                                    type="radio"
                                                    class="btn-check"
                                                    [value]="opt.value"
                                                    [formControl]="idmsFormGroup.get('barcodeFormGroup').get('ReportBarcode_Visible')"
                                                    autocomplete="off"
                                                />
                                                {{ opt.label }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="btn-group custom-toggle-wrap" role="group">
                                            <label
                                                *ngFor="let opt of stateOptions2"
                                                class="btn custom-toggle"
                                                [class.active]="opt.value === idmsFormGroup.get('barcodeFormGroup').get('ReportQRCode_Visible')?.value"
                                            >
                                                <input
                                                    type="radio"
                                                    class="btn-check"
                                                    [value]="opt.value"
                                                    [formControl]="idmsFormGroup.get('barcodeFormGroup').get('ReportQRCode_Visible')"
                                                    autocomplete="off"
                                                />
                                                {{ opt.label }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mb-3 mx-1">
                            <div class="col-xl-4 col-lg-5 col-5">
                                <mat-label class="text-dark mt-4 mb-4 font-14 font-400 labelpbutton">
                                    <!-- Method -->
                                    {{ 'SETTING_PAGE.IDMS_SETTINGS.TAGS' | transloco }}
                                </mat-label>
                            </div>

                            <div class="col-xl-8 col-lg-7 col-7 barcode-select-btn">
                                <div class="row">
                                    <div class="col-6">
                                        <div class="btn-group custom-toggle-wrap" role="group">
                                            <label
                                                *ngFor="let opt of stateOptions3"
                                                class="btn custom-toggle"
                                                [class.active]="opt.value === idmsFormGroup.get('barcodeFormGroup').get('TagBarcode_Visible')?.value"
                                            >
                                                <input
                                                    type="radio"
                                                    class="btn-check"
                                                    [value]="opt.value"
                                                    [formControl]="idmsFormGroup.get('barcodeFormGroup').get('TagBarcode_Visible')"
                                                    autocomplete="off"
                                                />
                                                {{ opt.label }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
